namespace('compass.tiles');

compass.tiles.MoreRoomsTileWidget = compass.defineWidget(function MoreRoomsTileWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;

	/* accessibilty structure */
	var accessibilty = {
		TAB_INDEX: 0
	};

	this.render = function(widgetElem) {
		widgetElem.append(d.div({ className : 'smallTile tile', tabindex: accessibilty.TAB_INDEX},
			d.div({ className : 'smallTileHeader' },
				d.h3({ className : 'headerCopy' }, 'Need More Rooms?'),
				//d.div({ className : 'whiteTriangle' }),
				d.div({ className : 'endHeader' })
			),
			d.div({ className : 'smallTileCopy'}, d.a({href:'javascript:;'},'Click here to shop hotels and add rooms to your group reservation.'))
		).activate(goHome));
	};
	
	function goHome() {
		if (_settings.groupMax > -1 && _settings.roomsBooked >= _settings.groupMax) {
			d.alert('Your group has reached its maximum allowed reservations.');
			return false;
		}

		me.trigger('MoreRoomsTileWidget.findMoreRooms');
	}

	var d = $j.dom.getContext(this);
}, {
	GUID : 'defaultMoreRoomsTileWidgetGUID',
	widgetName : 'MoreRoomsTileWidget'
});

